/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insight_Pain_CheckinInputs */

const en_us2_insight_pain_checkin = /** @type {(inputs: Insight_Pain_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is your body after the last workout? It takes ten seconds.`)
};

const pt_br2_insight_pain_checkin = /** @type {(inputs: Insight_Pain_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como está o corpo depois do último treino? Leva dez segundos.`)
};

const es_419_insight_pain_checkin = /** @type {(inputs: Insight_Pain_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo está tu cuerpo después del último entrenamiento? Toma diez segundos.`)
};

const pt_pt2_insight_pain_checkin = /** @type {(inputs: Insight_Pain_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como está o corpo depois do último treino? Demora dez segundos.`)
};

const fr_fr2_insight_pain_checkin = /** @type {(inputs: Insight_Pain_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment va ton corps après ta dernière séance ? Ça prend dix secondes.`)
};

const de_de2_insight_pain_checkin = /** @type {(inputs: Insight_Pain_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie fühlt sich dein Körper nach dem letzten Training an? Dauert zehn Sekunden.`)
};

const it_it2_insight_pain_checkin = /** @type {(inputs: Insight_Pain_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come sta il tuo corpo dopo l'ultimo allenamento? Ci vogliono dieci secondi.`)
};

/**
* | output |
* | --- |
* | "How is your body after the last workout? It takes ten seconds." |
*
* @param {Insight_Pain_CheckinInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const insight_pain_checkin = /** @type {((inputs?: Insight_Pain_CheckinInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insight_Pain_CheckinInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_insight_pain_checkin(inputs)
	if (locale === "es-419") return es_419_insight_pain_checkin(inputs)
	if (locale === "pt-PT") return pt_pt2_insight_pain_checkin(inputs)
	if (locale === "fr-FR") return fr_fr2_insight_pain_checkin(inputs)
	if (locale === "de-DE") return de_de2_insight_pain_checkin(inputs)
	if (locale === "it-IT") return it_it2_insight_pain_checkin(inputs)
	return en_us2_insight_pain_checkin(inputs)
});
export { insight_pain_checkin as "insight.pain_checkin" }